import * as React from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";
import { ButtonListTiny } from "./ButtonListTiny";
import { Strings } from "../Stores/StringsStore";

@observer
export class FavouriteButtonListTiny extends ButtonListTiny {

	@computed get classNames() {
		switch (this.props.switchState) {
			case 0:
				return "type-favourite-bg-2";
			case 1:
				return "type-favourite-bg-1";
			default:
				return "type-favourite-bg-2";
		}
	}

	@computed get tooltip() {
		switch (this.props.switchState) {
			case 0:
				return Strings.reader.removeFavoriteButtonTooltip;
			case 1:
				return Strings.reader.addFavoriteButtonTooltip;
			default:
				return Strings.reader.removeFavoriteButtonTooltip;
		}
	}

	render() {
		return <ButtonListTiny {...this.props} title={this.props.title ? this.props.title : this.tooltip}>

			<i className={this.classNames} />

		</ButtonListTiny>;
	}
}
